<template>
  <div class="contacts-find-us">
    <h3>{{ $t('find.us') }}</h3>
    <p>{{ $t('contacts.consent') }}</p>
    <p>{{ $t('contacts.address') }}</p>
    <div v-a11y-tab class="phone-container" @click="showModal">
      <img src="img/icons/phone.svg" :alt="$t('phone')" />
      <p>{{ $t('phone') }}</p>
    </div>
    <contacts-modal :visible="visible" @cancel="handleCancel" />
  </div>
</template>

<script>
import ContactsModal from './ContactsModal.vue';

export default {
  components: {
    ContactsModal,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/breakpoints';

.contacts-find-us {
  padding: 75px 95px;
  color: $dark-grey;
}
h3 {
  font-size: $font-size-headline-small;
  font-weight: bold;
  margin-bottom: 8px;
}
p {
  max-width: 233px;
  font-size: $font-size-large;
  letter-spacing: 0.17px;
  line-height: 28px;
}
.phone-container {
  display: flex;
  padding: 25px 0;
  cursor: pointer;

  p {
    color: $blue;
    padding-left: 15px;
  }
}

@media (max-width: $login-base-breakpoint) {
  .contacts-find-us {
    padding: 50px 15px 0 15px;
  }
}
</style>
